import React, { useState, useEffect } from "react";
import StatCard from "../Common/StatCard";
import LogIcon from "../../assets/icons/log";
import PlusIcon from "../../assets/icons/plus";
import LeaveHistoryTable from "../Common/LeaveHistoryTable";
import LeaveRequestTable from "../Common/LeaveRequestTable";
import api from "../../setupMiddleware";
import { getUser, hasPermission } from "../../Utils/auth";
import Popup from "../Common/Popup";
import CustomSelect from "../Common/CustomSelect";
import Input from "../Common/CustomInput";
import Textarea from "../Common/Textarea";
import FileUpload from "../Common/FileUpload";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import { createLeaveFormData } from "../../Utils/getUserUtitls";
import { ToastContainer, toast, Bounce } from "react-toastify";
import DateRange from "../Common/DateRange";
import moment from "moment/moment";
import ChipInput from "../Common/ChipInput";

const LeaveManagement = () => {
  const loading = useApiLoader();
  const [leaveHistory, setLeaveHistory] = useState([]);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [leaveSummary, setLeaveSummary] = useState({});
  const [applyLeaveOpen, setApplyLeaveOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leave, setLeave] = useState({
    leave_type: "",
    start_date: "",
    sub_type: "",
    end_date: "",
    medical_certificate: null,
    reason: "",
  });

  const currentUser = getUser();

  const {
    leave_type,
    sub_type,
    start_date,
    end_date,
    reason,
    medical_certificate,
  } = leave;

  const leaveTypeOptions = leaveTypes?.map((dep) => ({
    label: dep.name,
    value: dep.id,
  }));

  const leaveSubTypeOptions = [
    {
      label: "Full Day",
      value: "full_day",
    },
    {
      label: "First Half",
      value: "first_half",
    },
    {
      label: "Second Half",
      value: "second_half",
    },
    {
      label: "Short Leave",
      value: "short_leave",
    },
  ];

  const getLeaveType = async () => {
    try {
      await api.get("/api/leaves/types").then((res) => {
        if (res && res.status === 200) {
          const filteredData = res.data?.data
            ?.filter((item) => item.code !== "SL") // remove sick leave
            ?.map((item) => {
              if (item.code === "CL") {
                return {
                  ...item,
                  name: "Casual Leave ( Unpaid Leave )", // rename CL here
                };
              }
              return item;
            });

          setLeaveTypes(filteredData);
        }
      });
    } catch (error) {
      alert("Something went wrong!");
    }
  };

  const getLeaveHistory = async () => {
    try {
      await api.get(`/api/leaves/history/${currentUser?.id}`).then((res) => {
        if (res && res.status === 200) {
          const resData = res.data?.data;
          let pendingArray = [];
          let historyArray = [];
          resData?.map((item) => {
            item.status === "Approved" || item.status === "Rejected"
              ? historyArray.push(item)
              : pendingArray.push(item);
          });
          setLeaveHistory(historyArray);
          setLeaveRequests(pendingArray);
        }
      });
    } catch (error) {
      alert("Something went wrong!");
    }
  };

  const getLeaveSummary = async () => {
    await api
      .post(`/api/leaves/summary`, { user_id: currentUser?.id })
      .then((res) => {
        if (res && res.status === 200) {
          setLeaveSummary(res.data?.data);
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      });
  };

  // const getPendingLeave = async () => {
  //   try {
  //     await api
  //       .get(`/api/user-pending-leaves/${currentUser?.id}`)
  //       .then((res) => {
  //         if (res && res.status === 200) {
  //           setLeaveRequests(res.data?.data);
  //         }
  //       });
  //   } catch (error) {
  //     alert("Something went wrong!");
  //   }
  // };

  const applyLeave = async () => {
    setSubmitted(true);

    if (!leave_type || !start_date || !end_date || !reason) {
      setErrorMessage("Please fill all fields to apply for leave");
      return;
    }

    if (leave_type === 3 && !medical_certificate) {
      setErrorMessage("Please upload Medical Certificate");
      return;
    }

    if ((leave_type === 1 || leave_type === 8) && !sub_type) {
      setErrorMessage("Please select Sub Type");
      return;
    }
    try {
      const leaveData = {
        user_id: currentUser?.id,
        hr_id: currentUser?.hr_id,
        tl_id: currentUser?.tl_id,
        medical_certificate: medical_certificate,
        leave_type: leave_type,
        sub_type: sub_type,
        start_date: moment(new Date(start_date)).format("YYYY-MM-DD"),
        end_date: moment(new Date(end_date)).format("YYYY-MM-DD"),
        reason: reason,
      };
      const formData = createLeaveFormData(leaveData);
      await api.post("/api/leaves/apply", formData).then((res) => {
        if (res && res.status === 200) {
          setErrorMessage("");
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          setLeave({
            leave_type: "",
            start_date: "",
            end_date: "",
            medical_certificate: null,
            reason: "",
          });
          setApplyLeaveOpen(false);
          getLeaveHistory();
          // getPendingLeave();
          setSubmitted(false);
        }
      });
    } catch (error) {
      toast.error(error.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const handleApplyClose = () => {
    setLeave({
      leave_type: "",
      start_date: "",
      sub_type: "",
      end_date: "",
      medical_certificate: null,
      reason: "",
    });
    setApplyLeaveOpen(false);
    setSubmitted(false);
    setErrorMessage("");
  };

  useEffect(() => {
    getLeaveType();
    getLeaveHistory();
    getLeaveSummary();
  }, []);

  const stats = [
    {
      title: "Leave Entitlement",
      value: leaveSummary?.total_leaves ? leaveSummary?.total_leaves : "0",
      Icon: LogIcon,
    },
    {
      title: "Leave Balance",
      value: leaveSummary?.leave_balance ? leaveSummary?.leave_balance : "0",
      Icon: LogIcon,
    },
    {
      title: "Approved Leaves",
      value: leaveSummary?.approved_leaves
        ? leaveSummary?.approved_leaves
        : "0",
      Icon: LogIcon,
    },
    {
      title: "Rejected Leaves",
      value: leaveSummary?.rejected_leaves
        ? leaveSummary?.rejected_leaves
        : "0",
      Icon: LogIcon,
    },
  ];

  // automatically clear error after 5 seconds
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000); // 5s

      // cleanup if message changes before 5s
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  console.log(leave);
  return (
    <>
      {loading && <Loader fullscreen opacity={90} />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Leave Management
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Apply for leave and track your requests
          </span>
        </p>
        {hasPermission("apply_leaves") && (
          <div className="flex">
            <button
              onClick={() => setApplyLeaveOpen(true)}
              className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
            >
              <PlusIcon iconClass="w-4 h-4" color="#ffffff" />
              Apply Leave
            </button>
          </div>
        )}
        <Popup
          isOpen={applyLeaveOpen}
          onClose={() => handleApplyClose()}
          title="Apply Leave"
        >
          <div className="flex flex-col gap-6 mt-[30px]">
            {errorMessage && (
              <div className="mb-4 w-full rounded-lg bg-red-50 border border-red-400 text-red-700 px-4 py-2">
                {errorMessage}
              </div>
            )}
            <div className="flex flex-col gap-2 w-full">
              <p className="text-sm text-[#142b70]/80">Leave Type</p>
              <CustomSelect
                options={leaveTypeOptions}
                value={leave_type}
                placeholder="Leave Type"
                width="w-full"
                height="h-[46px]"
                fontSize="14px"
                onChange={(op) =>
                  setLeave({
                    ...leave,
                    leave_type: op.value,
                    sub_type: "",
                  })
                }
                error={!leave_type && submitted}
              />
            </div>
            {leave_type === 3 && (
              <div className="flex flex-col gap-2">
                <div className="relative">
                  <FileUpload
                    label="Upload Medical Certificate"
                    accept=".jpg,.pdf,.doc"
                    multiple={false}
                    onChange={(file) =>
                      setLeave({ ...leave, medical_certificate: file })
                    }
                    required={true}
                    submitted={submitted}
                  />
                </div>
              </div>
            )}
            {(leave_type === 1 || leave_type === 8) && (
              <div
                className={`flex flex-col justify-center gap-2 w-full border border-gray-200 rounded-lg shadow-sm p-4 bg-white ${
                  !sub_type && submitted ? "border-red-500" : ""
                }`}
              >
                <p className="text-sm text-[#142b70]/80">Leave Sub Type</p>
                <ChipInput
                  options={leaveSubTypeOptions}
                  onChange={(op) => setLeave({ ...leave, sub_type: op })}
                  selected={sub_type}
                />
              </div>
            )}
            <div className="flex justify-center gap-5 w-full">
              <DateRange
                startDate={start_date}
                endDate={end_date}
                setStartDate={(date) =>
                  setLeave({ ...leave, start_date: date })
                }
                setEndDate={(date) => setLeave({ ...leave, end_date: date })}
                submitted={submitted}
              />
            </div>
            <div className="flex flex-col gap-2 mb-4">
              <p className="text-sm text-[#142b70]/80">Reason</p>
              <div className="relative">
                <Textarea
                  value={reason}
                  placeholder="Write a reason"
                  onChange={(e) =>
                    setLeave({
                      ...leave,
                      reason: e.target.value,
                    })
                  }
                  error={!reason && submitted}
                  rows={4}
                />
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className="flex justify-end gap-4">
            <button
              onClick={() => handleApplyClose()}
              className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
            >
              Cancel
            </button>
            <button
              onClick={applyLeave}
              className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
            >
              Apply
            </button>
          </div>
        </Popup>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full mx-auto px-4 py-3">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                Leave Requests
              </p>
            </div>
            <LeaveRequestTable data={leaveRequests} />
          </div>
        </div>
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                Leave History
              </p>
            </div>
            <LeaveHistoryTable data={leaveHistory} />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default LeaveManagement;
